export const boxshadow = {
  shadow2_2_8: "2px 2px 8px rgba(0, 0, 0, 0.12)",
};

export type BoxshadowType = typeof boxshadow;
